import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { AddCartItemModel } from "../models/CartModel";
import { CartItemService, CartService } from "../services/CartService";

export default function useBasicCartVM() {
    const service = new CartService();
    const itemService = new CartItemService();

    const [cartId, setCartId] = useState(0);
    const [count, setCount] = useState(0);

    const onLoad = () => {
        console.log("cart loaded");
        get();
    };

    const get = () => {
        getUserCartId();
    };

    const getUserCartId = () => {
        const onResult = (result: IDataResult) => {
            if (result.status !== ResponseStatus.fail) {
                const cartId = result.data as number;
                setCartId(cartId);
                getCount(cartId);
            } else {
                clear();
            }
        };

        const request = service.getUserCartId();
        DataUtils.onRequest(request, onResult, false, false);
    };

    const getCount = (cartId: number) => {
        const onResult = (result: IDataResult) => {
            if (result.status !== ResponseStatus.fail) {
                const newCount = result.data as number;
                setCount(newCount);
            }
        };

        const request = service.getCount(cartId);
        DataUtils.onRequest(request, onResult);
    };

    const add = (productId: number, qty: number) => {
        if (cartId <= 0) {
            console.log("add cart id <= 0");
            get();
            return;
        }

        const model: AddCartItemModel = {
            cartId: cartId,
            productId: productId,
            qty: qty
        };

        const onResult = (result: IDataResult) => {
            if (result.status !== ResponseStatus.fail) {
                getCount(cartId);
            }
        };

        const request = itemService.add(model);
        DataUtils.onRequest(request, onResult);
    };

    const getCountText = () => {
        return count === 0 ? "" : count.toString();
    };

    const clear = () => {
        setCartId(0);
        setCount(0);
    };

    return {
        cartId,
        count,
        getCountText,

        onLoad,
        add
    }
}